import {
    TP_ADD_GROUP,
    TP_ADD_TRAINER,
    TP_ADD_USER,
    TP_INIT_PLAN,
    TP_REMOVE_GROUP,
    TP_REMOVE_TRAINER,
    TP_REMOVE_USER,
    TP_RESET,
    TP_SET,
    TP_SET_CAPACITIES,
    TP_SET_CELLSTATUS,
    TP_SET_COLSIZES,
    TP_SET_DEMO,
    TP_SET_GROUPS,
    TP_SET_IMPORTS,
    TP_SET_OVERLAY,
    TP_SET_SETTINGS,
    TP_SET_TRAINERS,
    TP_SET_USERS,
    TP_UPDATE_GROUPS,
    TP_UPDATE_SLOTS,
    TP_UPDATE_TAGS,
    TP_UPDATE_TRAINER,
    TP_UPDATE_USER
} from "../actions/types";
import { omit } from "lodash";

const initialState = {
    id: null,
    name: "",
    groups: {},
    imports: [],
    tags: [],
    slots: [],
    users: [],
    capacities: null,
    trainers: [],
    clubSlug: null,
    demoAccessToken: null,
    transfer_token: null,
    helpers: {
        columnSizes: {},
        cellStatus: {}
    },
    settings: {
        table: {
            days: [],
            times: []
        },
        scale: 2
    },
    overlay: {
        title: "",
        show: false,
        content: null
    }
};

const trainingplanReducer = (state = initialState, action) => {
    switch (action.type) {
        case TP_SET:
            return {
                ...state,
                ...action.payload
            };

        case TP_INIT_PLAN:
            return {
                ...state,
                id: action.payload.id,
                name: action.payload.name,
                groups: action.payload.groups,
                users: action.payload.users,
                tags: action.payload.tags,
                slots: action.payload.slots,
                imports: action.payload.imports,
                settings: { ...state.settings, table: action.payload.table },
                trainers: action.payload.trainers,
                capacities: action.payload.capacities,
                clubSlug: action.payload.clubSlug,
                demoAccessToken: action.payload.demoAccessToken,
                transfer_token: action.payload.transfer_token
            };

        case TP_SET_CAPACITIES:
            return {
                ...state,
                capacities: action.payload
            };

        //  Users
        case TP_SET_USERS:
            return {
                ...state,
                users: action.payload
            };

        case TP_ADD_USER:
        case TP_UPDATE_USER:
            return {
                ...state,
                users: { ...state.users, [action.payload.id]: action.payload }
            };

        case TP_REMOVE_USER:
            return { ...state, users: omit(state.users, action.payload.id) };

        // Groups
        case TP_SET_GROUPS:
            return {
                ...state,
                groups: action.payload
            };

        case TP_ADD_GROUP: {
            if (action.payload.start && action.payload.start !== "open") {
                return {
                    ...state,
                    groups: {
                        ...state.groups,
                        [action.payload.start]: [...(state.groups[action.payload.start] || []), action.payload]
                    }
                };
            }

            return {
                ...state,
                groups: { ...state.groups, open: [...(state.groups.open || []), action.payload] }
            };
        }

        case TP_UPDATE_TAGS:
            return {
                ...state,
                tags: Array.isArray(action.payload)
                    ? action.payload
                    : state.tags.find((t) => t.id === action.payload.id)
                        ? state.tags.map((t) => (t.id === action.payload.id ? action.payload : t))
                        : [...state.tags, action.payload]
            };

        case TP_UPDATE_SLOTS:
            return {
                ...state,
                slots: Array.isArray(action.payload)
                    ? action.payload
                    : state.slots.find((t) => t.id === action.payload.id)
                        ? state.slots.map((t) => (t.id === action.payload.id ? action.payload : t))
                        : [...state.slots, action.payload]
            };

        case TP_REMOVE_GROUP:
            return {
                ...state,
                groups: {
                    ...state.groups,
                    [action.payload.start || "open"]: state.groups[action.payload.start || "open"].filter(
                        (g) => g.id !== action.payload.id
                    )
                }
            };

        case TP_UPDATE_GROUPS:
            return action.payload.reduce((newState, { group, source }) => {
                group.start = group.start || "open";
                if (source) source.start = source.start || "open";

                // update group values
                if (!source || source.start === group.start)
                    return {
                        ...newState,
                        groups: {
                            ...newState.groups,
                            [group.start]: newState.groups[group.start].map((g) => (g.id === group.id ? group : g))
                        }
                    };

                return {
                    ...newState,
                    groups: {
                        ...newState.groups,
                        [source.start]: newState.groups[source.start].filter((g) => g.id !== group.id),
                        [group.start]: [...(newState.groups[group.start] || []), group]
                    }
                };
            }, state);

        // Trainers
        case TP_SET_TRAINERS:
            return {
                ...state,
                trainers: action.payload
            };

        case TP_ADD_TRAINER:
        case TP_UPDATE_TRAINER:
            return {
                ...state,
                trainers: { ...state.trainers, [action.payload.id]: action.payload }
            };

        case TP_REMOVE_TRAINER:
            return { ...state, trainers: omit(state.trainers, action.payload.id) };

        case TP_SET_DEMO:
            return {
                ...state,
                demo: action.payload
            };

        case TP_SET_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.payload
                }
            };

        case TP_SET_CELLSTATUS:
            return {
                ...state,
                helpers: {
                    ...state.helpers,
                    cellStatus: action.payload
                }
            };

        case TP_SET_IMPORTS:
            return {
                ...state,
                imports: action.payload
            };

        case TP_SET_COLSIZES:
            return {
                ...state,
                helpers: {
                    ...state.helpers,
                    columnSizes: {
                        ...state.helpers.columnSizes,
                        ...action.payload
                    }
                }
            };

        case TP_RESET:
            return initialState;

        case TP_SET_OVERLAY:
            return {
                ...state,
                overlay: { ...state.overlay, ...action.payload }
            };

        default:
            return state;
    }
};

export default trainingplanReducer;
